/**
 * Dark Theme Definition
 * 
 * Definiert die Farbpalette und Konfiguration für das Dark Theme.
 * Kann später für CSS-Variablen oder erweiterte Theme-Features verwendet werden.
 */

import type { ThemeColors } from './light'

export const darkTheme: ThemeColors = {
  background: '#111827',
  foreground: '#f9fafb',
  primary: '#60a5fa',
  secondary: '#94a3b8',
  border: '#374151',
  muted: '#1f2937',
  accent: '#3b82f6'
}

/**
 * Dark Theme Konfiguration
 */
export const darkThemeConfig = {
  name: 'dark',
  colors: darkTheme,
  // Weitere Theme-spezifische Eigenschaften können hier hinzugefügt werden
  // z.B. borderRadius, spacing, etc.
} as const
















